/** Supabase/PostgREST errors are plain objects, unlike network Errors. */
export function contactMutationErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === "object" && "message" in error) {
    const message = error.message;
    if (typeof message === "string" && message.trim()) return message.trim();
  }
  return fallback;
}
